import { RequestStatus } from "./requestStatus"
import { AppAction } from "./appAction";

export class ActionStatus {
  
  constructor(public completed: boolean = false, public payload: any, public requestStatus = RequestStatus.SUCCESS, public action?: AppAction<any>) {

  }

}